import { animateAttribute, setCss, swalAlert } from '../functions.js';

export default class SyncronizeSwiperElement extends HTMLElement {


    connectedCallback() {
        this.addEventListener('swiperslidechange', (event) => {
            let otherSwipers = this.querySelectorAll('swiper-container');
            otherSwipers.forEach((swiperElement, index) => {
                if (swiperElement === event.target) {
                    return;
                }
                swiperElement.swiper.slideTo(event.target.swiper.activeIndex);
            });
        });
        
    }
};



window.customElements.define('sincronize-swiper', SyncronizeSwiperElement);

